<template>
  <article
    @focus="onFocus"
    @focusout="onFocusOut"
    @keyup.esc="onEscapeKeyUp"
    aria-haspopup="true"
    aria-controls="menu"
    id="accessibility-text-helper-container"
    tabindex="0"
  >
    <accessibility-text-helper-dropdown></accessibility-text-helper-dropdown>
  </article>
</template>

<script>
import AccessibilityTextHelperDropdown from './AccessibilityTextHelperDropdown.vue';

export default {
  name: 'AccessibilityTextHelper',
  components: { AccessibilityTextHelperDropdown },
  methods: {
    focusOnFirstListItem(target) {
      const firstLink = target.querySelector('ul button');
      if (firstLink) {
        firstLink.focus();
      }
    },
    forceFocusPreviousTarget() {
      // const toolbarButtons = document.querySelectorAll('ul.kwt-toolbar li.show > button');

      // if (toolbarButtons.length) {
      //   const lastButton = toolbarButtons[toolbarButtons.length - 1];
      //   lastButton.focus();
      // }

      const audioButton = document.querySelector('button#toggleAudioButton');

      if (audioButton) {
        audioButton.focus();
      }
    },
    isAnchorTag(target) {
      return target && target.nodeName === 'A';
    },
    isArticleTag(target) {
      return target && target.nodeName === 'ARTICLE';
    },
    isButtonTag(target) {
      return target && target.nodeName === 'BUTTON';
    },
    isListItemTag(target) {
      return target && target.nodeName === 'LI';
    },
    onEscapeKeyUp(event) {
      const el = document.getElementById('accessibility-text-helper-container');
      el.setAttribute('aria-expanded', 'false');

      const ul = el.querySelector('article');
      if (ul) ul.style.display = 'none';

      this.forceFocusPreviousTarget();
    },
    onFocus(event) {
      if (this.isAnchorTag(event.relatedTarget)) return;

      const el = event.target;

      el.setAttribute('aria-expanded', 'true');

      const ul = el.querySelector('article');
      if (ul) ul.style.display = 'block';

      this.$nextTick(() => {
        this.focusOnFirstListItem(el);
      });
    },
    onFocusOut(event) {
      if (
        event.relatedTarget.className.includes('accessibility-text-helper-dropdown-button') &&
        this.isButtonTag(event.relatedTarget) &&
        this.isListItemTag(event.relatedTarget.parentNode)
      )
        return;

      const el = document.getElementById('accessibility-text-helper-container');
      el.setAttribute('aria-expanded', 'false');

      const ul = el.querySelector('article');
      if (ul) ul.style.display = 'none';

      if (this.isArticleTag(event.relatedTarget)) {
        this.forceFocusPreviousTarget();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#accessibility-text-helper-container {
  position: relative;
  z-index: 1000;
  article {
    display: none;
    position: absolute;
    left: 8px;
    top: 8px;
    user-select: none;
    z-index: 1;
  }
}
</style>
